import centerOfMass from '@turf/center-of-mass';
import type { Feature, FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';

export class FeatureCollectionToCenterOfMass {
  public static transform(
    featureCollection: FeatureCollection,
  ): FeatureCollection<Geometry, { originalGeometry?: Geometry }> {
    return {
      type: 'FeatureCollection',
      features: featureCollection.features
        .filter(
          (feature) => feature.geometry && 'coordinates' in feature.geometry && feature.geometry.coordinates.length > 0,
        )
        .map((feature): Feature<Geometry, GeoJsonProperties & { originalGeometry?: Geometry }> => {
          if (feature.geometry.type !== 'Point') {
            return {
              ...feature,
              properties: {
                ...feature.properties,
                originalGeometry: feature.geometry,
              },
              geometry: centerOfMass(feature.geometry).geometry,
            };
          }

          return feature as Feature<Geometry, GeoJsonProperties & { originalGeometry?: Geometry }>;
        }),
    };
  }

  public static async fetch(url: string) {
    const data: FeatureCollection = await (await fetch(url)).json();

    return FeatureCollectionToCenterOfMass.transform(data);
  }
}
